import { CurrencyFormatter, Inception_Date } from "../chartHelper";
import { chartConfig } from "../chart.commonConfig";

import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const STATUS_BREAK_UP_HELPER = data => {
  const BAR_CHART_CONFIG = {
    chart: {
      ...chartConfig.chart,
      type: "column",
      className: "chart-background",
      spacingBottom: 50,
      height: 350,
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.FIRST_PAGE.FOURTH._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      text: ""
    },
    subtitle: {
      ...chartConfig.subtitle,
      y: 25,
      text: "",
      verticalAlign: "bottom"
    },
    xAxis: {
      visible: false
    },
    yAxis: {
      min: 0,
      title: {
        text: "Number of Projects"
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold"
        }
      }
    },
    legend: {
      x: 0,
      y: 150,
      shadow: false,
      useHTML: true,
      verticalAlign: "top",
      align: "right",
      layout: "vertical",
      labelFormatter: function() {
        return `<span class="section-third-lable" style="color: ${
          this.color
        }">${this.name.replace(/\//g, "/\n")}</span>`;
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        pointWidth: 60,
        dataLabels: {
          enabled: true,
          rotation: 0,
          style: {
            textOutline: "none",
            color: "#fff"
          }
        }
      },
      series: {
        animation: false,
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      }
    },
    series: []
  };

  // extract data for charts
  let totalCount = 0;
  const series = [];
  data.forEach(({ count, name }) => {
    totalCount += count;
    series.push({
      name,
      data: [count],
      style: {
        textOutline: "none",
        color: "#fff"
      }
    });
  });
  // set data
  BAR_CHART_CONFIG.title.text = `STATUS BREAKUP : TOTAL ${totalCount} PROJECTS`;
  BAR_CHART_CONFIG.subtitle.text = `Break-up of ${totalCount} projects monitored by PMG`;
  BAR_CHART_CONFIG.series = series;
  BAR_CHART_CONFIG.yAxis.max = totalCount;
  BAR_CHART_CONFIG.xAxis.categories = ["PROJECTS"];

  return BAR_CHART_CONFIG;
};

export const STATUS_BREAK_UP_COST_HELPER = data => {
  // for cost config
  const COST_CHART_CONFIG = {
    chart: {
      type: "column",
      ...chartConfig.chart,
      className: "chart-background",
      spacingBottom: 50,
      height: 350
    },
    title: {
      ...chartConfig.title,
      text: ""
    },
    subtitle: {
      ...chartConfig.subtitle,
      y: 25,
      text: "",
      verticalAlign: "bottom"
    },
    xAxis: {
      visible: false,
      categories: []
    },
    yAxis: {
      min: 0,
      title: {
        text: "Anticipated Investments (Lakh Cr.)"
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold"
        }
      },
      labels: {
        enabled: true,
        formatter: function() {
          return CurrencyFormatter(this.value / 100000).replace(/,/g, ".00");
        }
      },
      stackLabels: {
        enabled: true,
        formatter: function() {
          return CurrencyFormatter(this.total / 100000).replace(
            /,/g,
            ".00 Lakh Cr."
          );
        }
      }
    },
    legend: {
      x: 0,
      y: 150,
      shadow: false,
      useHTML: true,
      verticalAlign: "top",
      align: "right",
      layout: "vertical",
      labelFormatter: function() {
        return `<span class="section-third-lable" style="color: ${
          this.color
        }">${this.name.replace(/\//g, "/\n")}</span>`;
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        pointWidth: 60,
        visible: true,
        dataLabels: {
          allowOverlap: true,
          enabled: true,
          position: "center",
          verticalAlign: "middle",
          inside: true,
          rotation: 0,
          formatter: function() {
            return CurrencyFormatter(this.y / 100000).replace(/,/g, ".");
          },
          style: {
            textOutline: "none",
            color: "#fff"
          }
        }
      },
      series: {
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      }
    },
    series: [],
    tooltip: {
      formatter: function() {
        return `
                <b>
                  PROJECTS
                </b><br />
                <b>${
                  COST_CHART_CONFIG.xAxis.categories[this.colorIndex]
                }: ${CurrencyFormatter(this.y / 100000)} Lakh Cr</b>
              `;
      }
    }
  };

  // extract data for charts
  let totalCount = 0,
    totalCost = 0,
    series = [];
  //
  data.forEach(({ count, name, cost }) => {
    totalCount += count;
    totalCost += cost;
    series.push({ name, data: [cost] });
    COST_CHART_CONFIG.xAxis.categories.push(name);
  });

  COST_CHART_CONFIG.title.text = `INVESTMENT BREAKUP : TOTAL ${totalCount} PROJECTS`;
  COST_CHART_CONFIG.subtitle.text = `Break-up of ${CurrencyFormatter(
    totalCost / 100000
  )} Lakh Cr. anticipated investment`;
  COST_CHART_CONFIG.series = series;
  COST_CHART_CONFIG.yAxis.max = totalCost + 200000;

  return COST_CHART_CONFIG;
};
